module.exports = __webpack_public_path__ + "static/cliente_7-cc467aa169c92e73934a38cc81e89d0b.png";